import { DataType } from "@src/types/intelligence-search";
import { OperatorEnum } from "../enum";
import {
    IconCircleCheck,
    IconCircleDotted,
    IconEqual,
    IconEqualNot,
    IconListCheck,
    IconMathGreater,
    IconMathEqualGreater,
    IconMathLower,
    IconMathEqualLower,
    IconSpacingHorizontal,
    IconCalendarBolt,
    IconSearch,
} from "@tabler/icons-react";

export const FILTER_OPERATORS = [
    { label: "Equals", value: OperatorEnum.EQ },
    { label: "Like", value: OperatorEnum.LIKE },
    { label: "Not Equals", value: OperatorEnum.NOT_EQ },
    { label: "Greater Than", value: OperatorEnum.GT },
    { label: "Greater Than or Equal", value: OperatorEnum.GTE },
    { label: "Less Than", value: OperatorEnum.LT },
    { label: "Less Than or Equal", value: OperatorEnum.LTE },
    { label: "Between", value: OperatorEnum.BETWEEN },
    { label: "In Date Range", value: OperatorEnum.IN_DATE_RANGE },
    { label: "In List", value: OperatorEnum.IN },
    { label: "Is Null", value: OperatorEnum.IS_NULL },
    { label: "Is Not Null", value: OperatorEnum.IS_NOT_NULL },
];

export const OPERATOR_LABEL_MAP = FILTER_OPERATORS.reduce((acc, curr) => {
    acc[curr.value] = curr.label;
    return acc;
}, {} as Record<OperatorEnum, string>);

export const operatorMap: Record<DataType, OperatorEnum[]> = {
    string: [
        OperatorEnum.EQ,
        OperatorEnum.NOT_EQ,
        OperatorEnum.IN,
        OperatorEnum.IS_NULL,
        OperatorEnum.IS_NOT_NULL,
        OperatorEnum.LIKE,
    ],
    int: [
        OperatorEnum.EQ,
        OperatorEnum.NOT_EQ,
        OperatorEnum.GT,
        OperatorEnum.GTE,
        OperatorEnum.LT,
        OperatorEnum.LTE,
        OperatorEnum.BETWEEN,
        OperatorEnum.IN,
        OperatorEnum.IS_NULL,
        OperatorEnum.IS_NOT_NULL,
    ],
    float: [
        OperatorEnum.EQ,
        OperatorEnum.NOT_EQ,
        OperatorEnum.GT,
        OperatorEnum.GTE,
        OperatorEnum.LT,
        OperatorEnum.LTE,
        OperatorEnum.BETWEEN,
        OperatorEnum.IN,
        OperatorEnum.IS_NULL,
        OperatorEnum.IS_NOT_NULL,
    ],
    date: [
        OperatorEnum.EQ,
        OperatorEnum.NOT_EQ,
        OperatorEnum.GT,
        OperatorEnum.GTE,
        OperatorEnum.LT,
        OperatorEnum.LTE,
        OperatorEnum.BETWEEN,
        OperatorEnum.IS_NULL,
        OperatorEnum.IS_NOT_NULL,
        OperatorEnum.IN_DATE_RANGE,
    ],
    bool: [OperatorEnum.EQ, OperatorEnum.NOT_EQ, OperatorEnum.IS_NULL, OperatorEnum.IS_NOT_NULL],
};

export const operatorIconMap: Record<string, React.ReactNode> = {
    [OperatorEnum.EQ]: <IconEqual size={16} />,
    [OperatorEnum.LIKE]: <IconSearch size={16} />,
    [OperatorEnum.NOT_EQ]: <IconEqualNot size={16} />,
    [OperatorEnum.GT]: <IconMathGreater size={16} />,
    [OperatorEnum.GTE]: <IconMathEqualGreater size={16} />,
    [OperatorEnum.LT]: <IconMathLower size={16} />,
    [OperatorEnum.LTE]: <IconMathEqualLower size={16} />,
    [OperatorEnum.BETWEEN]: <IconSpacingHorizontal size={16} />,
    [OperatorEnum.IN_DATE_RANGE]: <IconCalendarBolt size={16} />,
    [OperatorEnum.IN]: <IconListCheck size={16} />,
    [OperatorEnum.IS_NULL]: <IconCircleDotted size={16} />,
    [OperatorEnum.IS_NOT_NULL]: <IconCircleCheck size={16} />,
};
